import de from './../images/icons/big9/deu.svg';
import dnk from './../images/icons/big9/dnk.svg';
import eng from './../images/icons/big9/eng.svg';
import fra from './../images/icons/big9/fra.svg';
import esp from './../images/icons/big9/esp.svg';
import ita from './../images/icons/big9/ita.svg';
import nor from './../images/icons/big9/nor.svg';
import se from './../images/icons/big9/se.svg';
import int from './../images/icons/big9/int.svg';

export const countriesIcons = {
    de: de,
    dk: dnk,
    eng: eng,
    fr: fra,
    es: esp,
    it: ita,
    no: nor,
    se: se,
};

export const internationalFlag = int;
